/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { View } from 'backbone.marionette';

import SpinnerView from '../SpinnerView';

import tmplPlaceholderView from './PlaceholderView.hbs';

const PlaceholderView = View.extend({
  template: tmplPlaceholderView,

  className: 'placeholder-view',

  ui: {
    viewContainer: '.placeholder-view-container'
  },

  regions: {
    viewContainer: '@ui.viewContainer'
  },

  childViewEvents: {
    'has:errors': 'onHasErrors',
    'no:errors': 'onNoErrors'
  },

  childViewTriggers: {},

  resolved: false,

  options() {
    return {
      placeholderView: new SpinnerView({
        spinner: {
          top: '0%'
        }
      })
    };
  },

  async initialize(options) {
    try {
      this.showPlaceholderView();

      const view = await options.viewPromise;
      this.resolved = true;
      if (!this.isDestroyed()) {
        _.forEach(view.triggers, (value, key) => {
          this.childViewTriggers[value] = value;
        });

        this.showChildView('viewContainer', view);
      }
    } catch (err) {
      this.resolved = true;
      if (options.onError) {
        options.onError.apply(this, err);
      }
    }
  },

  onRender() {
    if (!this.resolved) {
      this.showChildView('viewContainer', this.options.placeholderView);
    }
  },

  showPlaceholderView() {
    this.showChildView(
      'viewContainer',
      new SpinnerView({
        spinner: {
          top: '0%'
        }
      })
    );
  },

  onHasErrors() {
    this.trigger('has:errors');
  },

  onNoErrors() {
    this.trigger('no:errors');
  },

  async call(functionName, ...args) {
    if (
      this.getChildView('viewContainer')[functionName] &&
      _.isFunction(this.getChildView('viewContainer')[functionName])
    ) {
      return await this.getChildView('viewContainer')[functionName](...args);
    }
  }
});

export default PlaceholderView;
